package hk.com.vr360_demo2.webapp.component.viewer.component

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.img
import web.cssom.pct
import web.cssom.px

external interface AvatarViewProps : Props {
    var photoUrl: String?
}

val AvatarView = FC<AvatarViewProps> { props ->
    img {
        src = props.photoUrl ?: "/assets/images/default-avatar.svg"
        alt = "Agent"
        css {
            width = 44.px
            height = 44.px
            borderRadius = 50.pct
        }
    }
}

